document.addEventListener('DOMContentLoaded', function () {
    document.body.classList.add('loaded');

    var toTopLink = document.querySelector('.to-top-of-page__link');
    var scrY = window.scrollY;

    window.addEventListener('scroll', function () {
        scrY = window.scrollY;
        document.documentElement.style.setProperty('--scroll-y', (scrY + 'px'));

        if (scrY > 500) {
            toTopLink.classList.add('shown');
        } else {
            toTopLink.classList.remove('shown');
        }
    });
});
